import Selectize from '@selectize/selectize/dist/js/selectize';
import * as bootstrap from 'bootstrap/dist/js/bootstrap.esm';
import $ from 'jquery';
import 'src/compat/selectize-jquery4-compat';

Selectize.defaults.respect_word_boundaries = false;

window.$ = $;
window.jQuery = $;
window.bootstrap = bootstrap;
window.Selectize = Selectize;

window.$param = (...args) => (
  $.param(...args).replace(/%20/g, '+')
);

// NOTE: Cannot use import because it seems to be moved up, above where we
// define window.$.
require('jquery-ujs');
require('linkify-jquery');
require('ab-datepicker/js/datepicker');
require('selectize-plugin-a11y');

if (typeof window.timecopFreeze === 'function') {
  $(window.timecopFreeze);
}

$(() => {
  $('[data-bs-toggle="popover"]').each(function popoverInitializer() {
    return new bootstrap.Popover(this);
  });
  $('[data-bs-toggle="tooltip"]').each(function tooltipInitializer() {
    return new bootstrap.Tooltip(this);
  });
  $('[data-bs-toggle="tab"]').each(function tabInitializer() {
    return new bootstrap.Tab(this);
  });
});
